import BordPhoto from 'components/NudosComponents/BordPhoto/BordPhoto';
import { IToolData } from 'types/products';
import BordBadge from 'components/NudosComponents/BordBadge/BordBadge';
import NudosProductPills from 'components/NudosComponents/NudosProductPills/NudosProductPills';
import { IpillsByReference } from 'types/orders';
import { BordOneToneIcon } from 'components/NudosComponents';
import BordTooltip from 'components/BordTooltip/BordTooltip';
import { TOOL_STATUS_NAME } from 'types/tools';
import { bordColorTheme } from 'styles/styles.constants';
import './ProductInformation.scss';

const ProductInformation = ({ productData }: IProductInformationProps) => {
  const formattedPills =
    typeof productData?.pills === 'string'
      ? (JSON.parse(productData?.pills) as IpillsByReference)
      : productData?.pills || {};
  const labelBadge = productData?.isManageable ? 'Gestionable' : 'No gestionable';
  const variantBadge = productData?.isManageable ? 'available' : 'unavailable';

  const tooltipMessage: Record<TOOL_STATUS_NAME, string> = {
    [TOOL_STATUS_NAME.AVAILABLE]: 'Esta herramienta está disponible para ser gestionada.',
    [TOOL_STATUS_NAME.BUY_BACK]: 'Esta herramienta se ha vendido a Bord, no está disponible para su gestión.',
    [TOOL_STATUS_NAME.SOLD_TO_THIRD_PARTY]: 'Esta herramienta ya fue vendida y no está disponible para su gestión.',
    [TOOL_STATUS_NAME.LOST]: 'Esta herramienta se ha perdido, no está disponible para su gestión.',
    [TOOL_STATUS_NAME.DONATED]: 'Esta herramienta se ha donado, no está disponible para su gestión.',
    [TOOL_STATUS_NAME.DAMAGED]: 'Esta herramienta se ha dañado, no está disponible para su gestión.',
    [TOOL_STATUS_NAME.DESTROYED]: 'Esta herramienta se ha destruido, no está disponible para su gestión.',
    [TOOL_STATUS_NAME.OUTBOUND_SHIPMENT]: 'Esta herramienta ya tiene una salida certificada.',
    [TOOL_STATUS_NAME.WAREHOUSE]: 'La herramienta está en bodega, pendiente del proceso de inventariar',
    [TOOL_STATUS_NAME.WARRANTY]: 'La herramienta se encuentra en revisión',
    [TOOL_STATUS_NAME.DIAGNOSTIC]: 'La herramienta se encuentra en revisión',
    [TOOL_STATUS_NAME.IN_MOVEMENT]: 'La herramienta se encuentra en una orden o servicio activa'
  };

  if (!productData) return null;
  return (
    <div className="productInformation">
      <div className="containerImageProduct">
        <BordPhoto
          variant="square"
          url={productData?.image ?? undefined}
          oneToneIconProps={{
            variant: 'bordMascot',
            standardSize: 14
          }}
          className="imageProduct"
          showSkeletonLoader={!productData?.image}
        />
      </div>
      <div className="productInformationContent">
        <BordBadge
          variant={variantBadge}
          Jsx={
            <div className="productInformationBadge">
              {labelBadge}
              <BordTooltip
                position="bottom"
                customJSXMessage={
                  <div
                    style={{
                      width: '150px'
                    }}
                  >
                    {tooltipMessage[productData?.status?.name as TOOL_STATUS_NAME]}
                  </div>
                }
              >
                <BordOneToneIcon
                  variant="alertCircleWarning"
                  stroke={productData?.isManageable ? bordColorTheme.green[600] : bordColorTheme.redBright[500]}
                  standardSize={8}
                />
              </BordTooltip>
            </div>
          }
        />
        <div className="contentName">
          <p className="productInformationTitle">{productData?.name}</p>
          {productData?.brandImage && (
            <BordPhoto variant="circle" size="s20" url={productData?.brandImage ?? undefined} />
          )}
        </div>
        <NudosProductPills pills={formattedPills} characterLimit={6} />
      </div>
    </div>
  );
};
interface IProductInformationProps {
  productData: IToolData | null;
}
export default ProductInformation;
